export class ProviderKeys{
    static readonly JoyID: string = "joyid";
    static readonly InjectedWallet: string = "injected-wallet";
}